import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DualListComponent } from '../../dual-list/dual-list.component';
import { TimeInterval } from 'src/app/shop/entities/timeInterval';
import { ReservationService } from 'src/app/shared/services/reservation.service';
import { ReservationRuleService } from 'src/app/shared/services/reservationRule.service';

@Component({
  selector: 'app-reservation-overrides',
  templateUrl: './reservation-overrides.component.html',
  styleUrls: ['./reservation-overrides.component.scss']
})
export class ReservationOverridesComponent implements OnInit {

  currentDay: number;
  deliveryFee: string;
  errorOnDeliverySave: boolean = false;
  successfullySavedDelivery: boolean = false;
  savingDelivery: boolean;

  saving: boolean = false;

  allTimes: Array<any> = new Array<any>();

  key: string = 'id';

  successfullySaved: boolean = false;
  errorOnSave: boolean = false;

  dayList: any[] = [
    {day: 1, title: 'Monday'},
    {day: 2, title: 'Tuesday'},
    {day: 3, title: 'Wednesday'},
    {day: 4, title: 'Thursday'},
    {day: 5, title: 'Friday'},
    {day: 6, title: 'Saturday'},
    {day: 0, title: 'Sunday'},
  ];

  filter = false;
  keepSorted = true;
  sourceLeft = true;
  format: any = DualListComponent.DEFAULT_FORMAT;
  confirmed: Array<any> = new Array<any>();
  disabled = false;
  display: string = 'time';
  activeList: Array<TimeInterval> = new Array<TimeInterval>();
  currentDateString: string;

  dateForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private reservationService: ReservationService, private reservationRuleService: ReservationRuleService) { }

  ngOnInit(): void {

    this.dateForm = this.formBuilder.group({
      date: ['']
    })

    this.dateForm.get("date").valueChanges.subscribe(x => {
      if (!!this.dateForm.get("date").value) {
        var date = new Date(this.dateForm.get("date").value);
        const yy = new Date(date).getFullYear();
        const mm = new Date(date).getMonth() + 1;
        const dd = new Date(date).getDate();

        this.currentDateString = `${dd}-${mm}-${yy}`
        this.reservationService.GetAllReservationTimes(this.currentDateString).subscribe(x => {
          this.allTimes = x;
          this.reservationRuleService.GetDisabledSlotsForDate(this.currentDateString).subscribe(x =>  {
            this.confirmed = x;
            this.doReset();
          })
        });

      }
    });

    this.dateForm.get('date').setValue(new Date());

  }

  setActiveList(event: any) {
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.activeList = new Array<TimeInterval>();
    var eventIds = event.map(x => x._id);

    if (!!eventIds && eventIds.length > 0) {
      for (let i = 0; i < eventIds.length; i++) {
        var timeInterval = this.allTimes.find(x => x.id == eventIds[i]);
        if (!!timeInterval)
        {
          this.activeList.push(timeInterval);
        }
      }
    }
  }

  doReset() {
    this.activeList = new Array<any>();
    this.useAllTimes();
  }

  private useAllTimes() {
    this.key = 'id';
    this.display = 'time';
    this.keepSorted = true;
    this.activeList = this.allTimes.filter(x => !this.confirmed.includes(x));
    console.log(this.activeList);
  }

  public save() {
    this.saving = true;
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.reservationRuleService.updateReservationRules(this.confirmed, this.currentDateString).subscribe(x => {
      this.saving = false;
      this.errorOnSave = false;
      this.successfullySaved = true;
    },
     (error) => {
      this.saving = false;
      this.successfullySaved = false;
      this.errorOnSave = true;
     })
  }

}
